import MotionController from "../lib/motion_controller"
import { gsap, SplitText, EASE } from "../lib/motion"

// Masked line-by-line (or word-by-word) headline reveal, triggered when scrolled into view.
//   data-controller="split-text" data-split-text-by-value="lines|words"
export default class extends MotionController {
  static values = {
    by: { type: String, default: "lines" },
    stagger: { type: Number, default: 0.08 },
    start: { type: String, default: "top 85%" }
  }

  animate({ motion }) {
    if (!motion) return

    const by = this.byValue === "words" ? "words" : "lines"
    SplitText.create(this.element, {
      type: "lines, words",
      linesClass: "split-line",
      wordsClass: "split-word",
      mask: by,
      autoSplit: true,
      onSplit: (split) => gsap.from(split[by], {
        yPercent: 110,
        duration: 1,
        stagger: this.staggerValue,
        ease: EASE.out,
        scrollTrigger: { trigger: this.element, start: this.startValue, once: true }
      })
    })
  }
}
